<template>
  <div
    class="relative rounded-full overflow-clip flex justify-center items-center"
    :class="sizeClass"
  >
    <img
      v-if="!imgError"
      :src="personImgSrc"
      class="w-full object-cover absolute top-0"
      :alt="`Profile picture of ${person.full_name}`"
      @error="imgError = true"
    />
    <CircleUser v-else class="text-gray-400" />
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import CircleUser from "@/components/icons/CircleUser.vue";

const props = defineProps({
  person: { type: Object, required: true },
  size: { type: String, default: "lg" },
  customSizeClass: { type: String, required: false },
});

const imgError = ref(false);

const sizeClass = computed(() => {
  if (props.customSizeClass) {
    return props.customSizeClass;
  }
  return {
    "h-12 w-12": props.size === "sm",
    "h-16 w-16": props.size === "md",
    "h-24 w-24": props.size === "lg",
    "h-32 w-32": props.size === "xl",
  };
});

const personImgSrc = computed(() => {
  const size = ["lg", "xl"].includes(props.size) ? "Full" : "Thumb";
  const associateId = props.person.associate_id;
  return `https://ac2.st8fm.com/associate-photos/${Array.from(associateId)[0]}/${associateId}/formalColor${size}.jpg`;
});
</script>
